import { Fragment, h } from 'preact'; /** @jsx h */
import formatPrice from '../../utils/formatPrice';

import CartItem from '../CartItem/CartItem';
import Checkout from '../Checkout/Checkout';
import EmptyCart from '../EmptyCart/EmptyCart';
import ExtraContribution from '../ExtraContribution/ExtraContribution';
import TaxReduction from '../TaxReduction/TaxReduction';

import './CartView.scss';

const CartView = ({
    cart,
    total,
    isDetails,
    taxDeduction,
    viewContribution,
    viewContributionInput,
    viewTaxDeduction,
    removeFromCart,
    updateQty,
    setContributionValue,
    setViewContributionInput,
    setViewTaxDeduction,
    handleKeyPress,
    isTablet,
    tabletView,
    setTabletView
}) => {
    return (
        <div className="ws-products-container">
            <h1 className="ws-products-title">Handlevogn</h1>
            <div className="ws-products">
                {isDetails ? (
                    cart.map(item => (
                        <CartItem
                            key={item.id}
                            item={item}
                            updateQty={updateQty}
                            removeFromCart={removeFromCart}
                        />
                    ))
                ) : (
                    <>{isTablet && <EmptyCart />}</>
                )}
            </div>
            {viewContribution && (
                <ExtraContribution
                    setContributionValue={setContributionValue}
                    viewContributionInput={viewContributionInput}
                    setViewContributionInput={setViewContributionInput}
                    handleKeyPress={handleKeyPress}
                />
            )}
            <div className="ws-products-total">
                {isDetails && <h3 className="ws-total-sum">Totalt {formatPrice(total)},-</h3>}
            </div>
            {isTablet && total > 0 && tabletView === 'cart' && (
                <div className="ws-products-checkout">
                    <button className="ws-checkout-btn" onClick={() => setTabletView('order')}>
                        Gå til kassen
                    </button>
                </div>
            )}
            {isTablet && total > 0 && tabletView === 'order' && (
                <Checkout isTablet={isTablet} total={total} />
            )}
            {taxDeduction && (
                <TaxReduction
                    viewTaxDeduction={viewTaxDeduction}
                    setViewTaxDeduction={setViewTaxDeduction}
                />
            )}
        </div>
    );
};

export default CartView;
